var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"marketplace"}},[_c('ec-apps-market',{attrs:{"next-tab":_vm.nextTab,"additional-apps":_vm.mockedApps},on:{"click:app":_vm.goToApp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }